export const serverUrl = process.env.REACT_APP_SERVER_URL;
export const cmsUrl = process.env.REACT_APP_CMS_URL;
export const environment = process.env.REACT_APP_ENVIRONMENT;
export const showRewardsProgram = process.env.REACT_APP_SHOW_REWARDS_PROGRAM;
export const bookingSource = process.env.REACT_APP_BOOKING_SOURCE;
export const PLATFORM = process.env.REACT_APP_PLATFORM;
export const posAppId = process.env.REACT_APP_POS_APP_ID;
export const posTillNo = process.env.REACT_APP_POS_TILL_NO;
export const channel = process.env.REACT_APP_CHANNEL;
export const kiosk_terminal = process.env.REACT_APP_TERMINAL;
export const kiosk_sector = process.env.REACT_APP_SECTOR;
export const kiosk_movementType = process.env.REACT_APP_MOVEMENT_TYPE;
export const showDeliverToGate = process.env.REACT_APP_SHOW_DEL_TO_GATE;
export const hideDelSelectionPostStart =
  process.env.REACT_APP_HIDE_DEL_SELECTION_POST_START;
export const callPromoApi = process.env.REACT_APP_CALL_PROMO_API;
export const empPin = process.env.REACT_APP_EMP_PIN;
export const appLocationId = process.env.REACT_APP_LOCATION_ID;

export const ADYEN_CLIENT_KEY = process.env.REACT_APP_ADYEN_CLIENT_KEY;
export const GOOGLE_RECAPTCHA_SITE_KEY =
  process.env.REACT_APP_RECAPTCHA_SECRET_KEY;
export const ENTERPRISE_RECAPTCHA_ENABLED =
  process.env.REACT_APP_USE_ENTERPRISE_RECAPTCHA === "true";
export const fstrPreSelectionEnabled =
  process.env.REACT_APP_PREFERENCE_PRESELECTION_ENABLED;
export const PRODUCT_CDN_URL = process.env.REACT_APP_PRODUCT_CDN_URL;
export const SHOP_CDN_URL = process.env.REACT_APP_SHOP_CDN_URL;
export const SHOW_CART_COUPON = process.env.REACT_APP_SHOW_CART_COUPON;
export const FILTER_COMPONENT_ID = process.env.REACT_APP_FILTER_COMPONENT_ID;
export const ACCESSIBILITY_WIDGET_CLIENT_ID =
  process.env.REACT_APP_ACCESSIBILITY_WIDGET_CLIENT_ID;
export const SHOW_INACTIVITY_MODAL =
  process.env.REACT_APP_ENABLE_INACTIVITY_MODAL;

export const PAYMENT_SUCCESS_STATUS =
  process.env.REACT_APP_PAYMENT_SUCCESS_STATUS;

export const PAYMENT_FAILURE_STATUS =
  process.env.REACT_APP_PAYMENT_FAILURE_STATUS;

export const SHOW_ON_SCREEN_KEYBOARD =
  process.env.REACT_APP_SHOW_OSK === "true";

export const CONFIG_REQUIRED = process.env.REACT_APP_CONFIG_REQUIRED === "true";
export const PAYMENT_PROCESS_REFRESH_TIME =
  parseInt(process.env.REACT_APP_PAYMENT_PROCESS_REFRESH_TIME) || 2000;

export const SHORT_TIMER_LOCATIONS = (
  process.env.REACT_APP_SHORT_TIMER_LOCATIONS || ""
)
  .split(",")
  .map((l) => l.trim().toLowerCase())
  .filter(Boolean);

export const isShortTimerLocation = () => {
  const hostSegment = window.location.hostname.split(".")[0].toLowerCase();
  return SHORT_TIMER_LOCATIONS.some((loc) => hostSegment.endsWith(`-${loc}`));
};

export const STORES_CACHE_TIME =
  parseInt(process.env.REACT_APP_STORES_CACHE_TIME) || 30 * 1000;

export const GET_STORES_REFRESH_TIME =
  parseInt(process.env.REACT_APP_GET_STORES_REFRESH_TIME) || 60000;
export const ALLOWED_COUNTRY_CODES =
  process.env.REACT_APP_ALLOWED_COUNTRY_CODES.split(",") || [];
export const FULL_SCREEN_TOGGLE_PASSWORD =
  process.env.REACT_APP_FULL_SCREEN_TOGGLE_PASSWORD || "202506";

export const S3_URL = process.env.REACT_APP_S3_URL;

export const DEFAULT_PHONE_NUMBER = process.env.REACT_APP_DEFAULT_LOGIN_PH_NO;
export const DEFAULT_EMAIL = process.env.REACT_APP_DEFAULT_LOGIN_EMAIL;

export const SENTRY_ENABLED = process.env.REACT_APP_SENTRY_ENABLED === "true";
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

export const MOENGAGE_APP_ID = process.env.REACT_APP_MOENGAGE_APP_ID;
